/*
 * @Author: chenyingxuan chenyingxuan@abc.com
 * @Date: 2021-08-02 09:47:47
 * @LastEditors: chenyingxuan chenyingxuan@abc.com
 * @LastEditTime: 2024-08-08 13:25:31
 * @FilePath: /platform/src/views/form/htmb/constants.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
export const purposeList = [
  {
    name: "合同",
    code: 0
  },
  {
    name: "打印",
    code: 1
  }
];
export const typeList = [
  {
    name: "文本",
    code: "0"
  },
  {
    name: "数组",
    code: "1"
  },
  {
    name: "布尔值",
    code: "2"
  },
  {
    name: "数组字段",
    code: "3"
  },
  {
    name: "一对一数组字段",
    code: "4"
  }
];
export const dataSourceList = [
  {
    name: "常量",
    code: "0",
    disabled: false
  },
  {
    name: "模型",
    code: "1",
    disabled: false
  },
  {
    name: "用户",
    code: "2",
    disabled: false
  }
];
export const statusList = [
  {
    name: "停用",
    code: 0
  },
  {
    name: "启用",
    code: 1
  }
];
export const requiredList = [
  {
    name: "否",
    code: "0"
  },
  {
    name: "是",
    code: "1"
  }
];
